(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  function init(bar) {
    if (bar.dataset.initialized === 'true') return;

    const product = bar.closest('product-info[data-update-url="true"]');
    const button = bar.querySelector('[data-product-mobile-buy-button]');
    if (!product || !button) return;

    bar.dataset.initialized = 'true';
    // Dawn animates the product-info wrapper with transform, which would make
    // a nested position:fixed bar scroll with the product rather than the viewport.
    document.body.appendChild(bar);
    let scheduled = false;

    function refresh() {
      scheduled = false;
      const native = product.querySelector('product-form button[name="add"]');
      if (!native || !mobile.matches) {
        bar.hidden = true;
        return;
      }

      const disabled = native.disabled || native.getAttribute('aria-disabled') === 'true';
      if (button.disabled !== disabled) button.disabled = disabled;

      const label = native.textContent.trim();
      if (label && button.textContent.trim() !== label) button.textContent = label;

      const rect = native.getBoundingClientRect();
      const nativeVisible = rect.bottom > 0 && rect.top < window.innerHeight - 145;
      bar.hidden = nativeVisible;
    }

    function scheduleRefresh() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(refresh);
    }

    button.addEventListener('click', () => {
      const native = product.querySelector('product-form button[name="add"]');
      if (native && !native.disabled && native.getAttribute('aria-disabled') !== 'true') native.click();
    });

    window.addEventListener('scroll', scheduleRefresh, { passive: true });
    window.addEventListener('resize', scheduleRefresh);
    mobile.addEventListener('change', scheduleRefresh);
    new MutationObserver(scheduleRefresh).observe(product, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
    scheduleRefresh();
  }

  function start() {
    document.querySelectorAll('[data-product-mobile-buy-bar]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
